import React, { useState, useRef, useMemo } from 'react'
import { Model } from 'survey-core'
import { Survey } from 'survey-react-ui'
// import 'survey-core/defaultV2.min.css'

import { useConvertSurvey } from '../hooks/useConvertSurvey'
import { useSubmitAnswers } from '../hooks/useSubmitAnswers'
import 'survey-core/i18n/traditional-chinese'

const Agree = ({
  setAc,
  setTk,
  ac,
  tk,
  pid,
  setIsLoading,
  setCompletionMessage,
}) => {
  const [myAgreeJson, setMyAgreeJson] = useState(null)
  // 需要登入嗎
  const requiresLogin = {
    login: false,
    title: '驗證碼',
    placeholder: '請輸入驗證碼',
    alert: '請填寫您的手機或信箱',
  }
  const [imagesReadingTime, setImagesReadingTime] = useState(0)
  // 圖片閱讀時間(秒)
  // useEffect(() => {
  //   setImagesReadingTime(30)
  // }, [])
  const completedHtml = `<h3>問卷正在提交中，請稍候。</h3><h3>請在成功頁面顯示後再離開。</h3><h4>如有填卷相關問題請洽：</h4> <a href='https://lin.ee/HWETcqy'>https://lin.ee/HWETcqy</a><h4 style='margin-top:50px'>填寫其他問卷：</h4> <a href=${window.location.origin}>${window.location.origin}</a>`

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const agreeSurvey = new Model(myAgreeJson)

  // 問卷編號
  // const pid = pid
  // 跳題 小心複選題要用陣列

  agreeSurvey.onCurrentPageChanged.add(function (survey, options) {
    // 切換頁面時滾動到頂部
    window.scrollTo(0, 0)
  })

  // const visibleIfConditionsInit = {
  //   q6: '{q5} = 0 or {q5} = 1 or {q5} = 2 or {q5} = 3',
  //   q7: '{q6} = ["none"]',
  //   q36: `{q35} <> ['none']`,
  // }

  const visibleIfConditionsInit = {
    q3: '{q2} = 0',
    q4: '{q2} = 1',
    q5: '{q2} = 2',
    q6: '{q2} = 3',
    q7: '{q2} = 4',
    q8: '{q2} = 5',
    q9: '{q2} = 6',
    q10: '{q2} = 7',
    q11: '{q2} = 8',
    q12: '{q2} = 9',
    q13: '{q2} = 10',
    q14: '{q2} = 11',
    q15: '{q2} = 12',
    q16: '{q2} = 13',
    q17: '{q2} = 14',
    q18: '{q2} = 15',
    q19: '{q2} = 16',
    q20: '{q2} = 17',
    q21: '{q2} = 18',
    q22: '{q2} = 19',
    q23: '{q2} = 20',
    q24: '{q2} = 21',
    q27: '{q26} = 0 or {q26} = 1 or {q26} = 4 or {q26} = 5 or {q26} = 6',
    q28: '{q27} = 0 or {q27} = 1 or {q27} = 2 or {q27} = 3 or {q27} = 4 or {q27} = 5 or {q27} = 6 or {q27} = 7 or {q27} = 8 or {q27} = 9 or {q27} = 10 or {q27} = 11 or {q27} = 12 or {q27} = 13 or {q27} = 14 or {q27} = 15 or {q27} = 16 or {q27} = 17 or {q27} = 18 or {q27} = 19 or {q27} = 20 or {q27} = 21 or {q27} = 22 or {q27} = 23 or {q27} = 24 or {q27} = 25 or {q27} = 26 or {q27} = 27 or {q27} = 28 or {q27} = 29 or {q27} = 30 or {q27} = 31 or {q27} = 32 or {q27} = 33',
    q33: '{q32} = 0 or {q32} = 2',
    q34: '{q33} = 0',
    q35: '{q33} = 1',
    q36: '{q33} = 0 or {q33} = 1 or {q33} = 2',
    q37: '{q36} = 0',
    q38: '{q37} = 0',
    q39: '{q37} = 1',
    q40: '{q37} = 0 or {q37} = 1 or {q37} = 2',
    q41: '{q40} = 0',
    q42: '{q41} = 0',
    q43: '{q41} = 1',
    q45: '{q44} = 0 or {q44} = 1',
  }
  // const visibleIfConditionsInit = null
  // const pageVisibleIfConditionsInit = null

  // 非必填(從 0 計算)
  // const notRequired = [100]
  const notRequired = null

  const mappedRateChoice = null
  // const pageBreakQuestions = ['q6', 'q11', 'q15']
  const pageBreakQuestions = null

  const triggersConditionsInit = [
    // {
    //   type: 'complete',
    //   expression: '({q0} = 1) or ({q1} = 1)',
    //   //     expression: `{q3} <> 4 or ({q4} = 16 or {q4} = 20 or {q4} = 21)`,
    // },
  ]
  // const triggersConditionsInit = null
  // const pageVisibleIfConditionsInit = null

  const convertedSurvey = useConvertSurvey({
    survey: agreeSurvey,
    pid,
    setAc,
    setTk,
    ac,
    tk,
    setMyAgreeJson,
    imagesReadingTime,
    setImagesReadingTime,
    setIsLoading,
    completedHtml,
    visibleIfConditionsInit,
    notRequired,
    mappedRateChoice,
    pageBreakQuestions,
    requiresLogin,
    triggersConditionsInit,
  })

  // const newSurvey = new Model(convertedSurvey)

  const surveyModel = useMemo(() => {
    if (!convertedSurvey) return null
    return new Model(convertedSurvey)
  }, [convertedSurvey])
  // useEffect(() => {
  //   console.log('convertedSurvey', convertedSurvey)
  // }, [convertedSurvey])
  const endMessage = `很抱歉，目前與您相同特性的樣本已經額滿，沒辦法參與本次活動。歡迎您分享本問卷連結給其他親朋好友，或加入我們的<a href='https://lin.ee/HWETcqy'>LINE@</a>，隨時得到最新填問卷獲好禮的消息。<p>請按「完成」前往下載 EZChoice 或填寫更多問卷</p>`

  function helpFunction(survey, options) {
    // console.log('survey.getValue(q42)', survey.getValue('q42'))
    // 參考 P231113152849 或 P231101165555 或 P231206105643(政大帶入選項)
  }

  const endSurveyMsg = (survey) => {
    // if (survey.getValue('q0') === 1 || survey.getValue('q1') === 1) {
    //   setCompletionMessage(endMessage)
    // } else {
    //   setCompletionMessage(
    //     `<h4 style='text-align: center'>問卷已成功送出</h4><h4 style='text-align: center'>請按「完成」前往下載 EZChoice 或填寫更多問卷</h4>`
    //   )
    // }
  }

  const canShowPrevButtonPages = null
  const choicesOrderRef = useRef({})
  const choiceIndexMapRef = useRef({})

  useSubmitAnswers({
    survey: surveyModel,
    pid,
    ac,
    tk,
    imagesReadingTime,
    setIsLoading,
    helpFunction,
    canShowPrevButtonPages,
    choicesOrderRef,
    choiceIndexMapRef,
    endSurveyMsg,
  })

  return (
    <>
      {surveyModel ? (
        <Survey model={surveyModel} key={pid} />
      ) : myAgreeJson ? (
        <Survey model={agreeSurvey} />
      ) : (
        <></>
      )}
    </>
  )
}

export default Agree
